import { PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import cn from 'classnames';

import { useCertificatesPageHeader } from '../hooks/useCertificatesPageHeader';

import type { FC } from 'react';

export const CertificatesPageHeader: FC = () => {
  const { canCreate, isMobile, openCreateModal } = useCertificatesPageHeader();

  if (!canCreate) {
    return null;
  }

  // Space центрирует кнопку по высоте шапки, как в других headerContent
  return (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      className={cn({ 'full-width': isMobile })}
    >
      <Button
        type="primary"
        icon={<PlusOutlined />}
        className={cn({ 'full-width': isMobile })}
        onClick={openCreateModal}
        data-testid="add-certificate"
      >
        Добавить сертификат
      </Button>
    </Space>
  );
};
